import React from "react";
import { Link } from "react-router-dom";
import VND from "../../../../components/VND";
import { usePrimaryColor } from "../../../../components/PrimaryColorContext";


/**
 * Renders a student row with checkbox, name link, and total owed amount.
 * @date 2026-04-15
 * @version 2.0
 * @author Forge, opencode + glm-5
 */
export default function DrawStudentsNameAndTotal(props) {
  const { primaryColor } = usePrimaryColor();
  let { student, payment, setPayment } = props;
  return (
    <div>
      <div
        key={student._id}
        className="flex justify-between items-center"
        style={{
          color: !payment.excludedStudents.includes(student._id)
            ? "#1e293b"
            : "#94a3b8",
        }}
      >
        <div className="flex items-center gap-1">
          <input
            type="checkbox"
            checked={!payment.excludedStudents.includes(student._id)}
            onChange={(e) => studentCheck(e, student, payment, setPayment)}
            className={`h-3.5 w-3.5 rounded border-slate-300 text-${primaryColor}-800 focus:ring-${primaryColor}-800 cursor-pointer accent-${primaryColor}-800`}
          />
          <Link
            to={`/student/${student._id}`}
            className="neat"
            style={{
              color: !payment.excludedStudents.includes(student._id)
                ? "#1e293b"
                : "#94a3b8",
            }}
          >
            {student.name}
          </Link>
        </div>
        <div>
          <VND
            value={student.unpaidBills.reduce((a, b) => a + b.amount, 0)}
            style={{ marginRight: 14 }}
          />
        </div>
      </div>
    </div>
  );
}

function studentCheck(e, student, payment, setPayment) {
  if (e.target.checked) {
    let excludedStudents = payment.excludedStudents.filter(
      (exs) => exs !== student._id
    );
    let amount = recalcBills({ ...payment, excludedStudents });
    setPayment((prev) => ({ ...prev, amount, excludedStudents }));
    return;
  }
  let excludedStudents = [...payment.excludedStudents, student._id];
  let amount = recalcBills({ ...payment, excludedStudents });
  setPayment((prev) => ({ ...prev, amount, excludedStudents }));
}

function recalcBills(payment) {
  let amount = 0;
  payment.students
    .filter((student) => !payment.excludedStudents.includes(student._id))
    .forEach((student) => {
      amount += student.unpaidBills
        .filter((bill) => !payment.excludedBills.includes(bill._id))
        .reduce((a, b) => a + b.amount, 0);
    });
  return amount;
}